import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const loggedInGuard = (to, from, next) => {
  if (sessionStorage.getItem("loggedIn")) {
    next();
  } else {
    next("/");
  }
};

const notLoggedInGuard = (to, from, next) => {
  sessionStorage.setItem("pathname", location.pathname);
  if (sessionStorage.getItem("loggedIn")) {
    next("/dashboard");
  } else {
    next();
  }
};

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home.vue"),
      beforeEnter: notLoggedInGuard
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("./views/Dashboard.vue"),
      beforeEnter: loggedInGuard,
      children: [
        {
          path: "",
          component: () => import("./views/Dashboard/Doctors.vue")
        },
        {
          path: "patients",
          component: () => import("./views/Dashboard/Patients.vue")
        },
        {
          path: "admin",
          component: () => import("./views/Dashboard/Administrators.vue")
        },
        {
          path: "statistics",
          component: () => import("./views/Dashboard/Statistics.vue")
        },
        {
          path: "pushes",
          component: () => import("./views/Dashboard/Pushes.vue")
        }
      ]
    }
  ]
});
